export default __webpack_public_path__ + "static/tb_radler_01_EN-20f9b85fd236a9b6372c5c595338d29d.svg";